import { createSlice } from "@reduxjs/toolkit";
import { stateEnum } from "../constants/enum";

const { size } = stateEnum;

let initialState = {
    detailParams: {},
    isNewEntry: false
};


const sizeSlice = createSlice({
    name: size,
    initialState,
    reducers: {
        setNewEntryMode: (state, action) => {
            state.isNewEntry = action.payload;
        },
        setDetailParams: (state, action) => {
            state.detailParams = action.payload
          },
        resetDetail: (state) => {
            state.detailParams = {};
            state.isNewEntry = true;
        },
    },
    
});


export const { setNewEntryMode,setDetailParams, resetDetail } = sizeSlice.actions;
export default sizeSlice.reducer;
